"use client";

import { cn } from "@tillix/ui-atoms/lib/utils";
import { Mail, Phone } from "lucide-react";
import { useT } from "@/features/i18n/hooks/use-t";
import {
  supportContacts,
  supportEmail,
} from "@/features/support/support-contact-data";

export default function SupportContent() {
  const { t } = useT();

  return (
    <div className="w-full space-y-10 pb-10 sm:pb-0">
      <section>
        <h2 className="mb-6 font-semibold text-lg">
          {t("support.contactNumbers")}
        </h2>
        <div className="divide-y divide-border/50">
          {supportContacts.map((contact) => (
            <div
              className={cn(
                "flex items-center justify-between py-3 text-sm",
                contact.isEmergency && "text-destructive",
              )}
              key={contact.labelKey}
            >
              <span className="font-medium">{t(contact.labelKey)}</span>
              <a
                className="inline-flex items-center gap-1.5 hover:underline"
                href={`tel:${contact.phone.replaceAll("-", "")}`}
              >
                <Phone className="h-3.5 w-3.5" />
                {contact.phone}
              </a>
            </div>
          ))}
        </div>
      </section>

      <section>
        <h2 className="mb-4 font-semibold text-lg">
          {t("support.emailSupport")}
        </h2>
        <p className="text-muted-foreground text-sm leading-relaxed">
          {t("support.emailSupportDescription")}{" "}
          <a
            className="inline-flex items-center gap-1 text-primary hover:underline"
            href={`mailto:${supportEmail}`}
          >
            <Mail className="h-3.5 w-3.5" />
            {supportEmail}
          </a>
          .
        </p>
      </section>
    </div>
  );
}
